import { Page } from "../enums/Page";
import { css } from "../helpers/webComponents";
import { htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    button {
        background-color: #008CBA;
        color: white;
        padding: 12px 24px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        border-radius: 5px;
    }
    button:hover {
        background-color: #007B9E;
    }
    .confirm-dialog {
        position: fixed; 
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .confirm-dialog-inner {
        text-align: center;
        background-color: white;
        padding: 25px;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        width: 350px;
        font-size: 18px;
    }
    .button-container {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .confirm-dialog button {
        flex: 1;
        margin: 0 10px;
    }
    #confirmYes {
        background-color: #d9534f;
    }
    #confirmYes:hover {
        background-color: #c9302c;
    }
    #confirmNo {
        background-color: #5bc0de;
    }
    #confirmNo:hover {
        background-color: #46b8da;
    }
`;

export class AuthButtonComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();
    private isLoggedIn: boolean = false;

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.checkLoginStatus();
        this.render();
        this.addEventListeners();
    }

    private checkLoginStatus(): void {
        const playerSessionId: string | null = localStorage.getItem("playerSessionId");
        const isLoggedIn: string | null = localStorage.getItem("isLoggedIn");
        this.isLoggedIn = !!playerSessionId && isLoggedIn === "true";
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const buttonHtml: string = this.isLoggedIn
            ? "<button id=\"logoutButton\">Uitloggen</button>"
            : "<button id=\"loginButton\">Inloggen/Registreren</button>";

        const elements: HTMLElement[] = htmlArray`
            <style>${styles}</style>
            ${buttonHtml}
        `;

        this.shadowRoot.innerHTML = "";
        this.shadowRoot.append(...elements);
    }

    private addEventListeners(): void {
        const shadowRoot: ShadowRoot | null = this.shadowRoot;
        if (!shadowRoot) return;

        const loginButton: HTMLElement | null = shadowRoot.querySelector("#loginButton");
        const logoutButton: HTMLElement | null = shadowRoot.querySelector("#logoutButton");

        if (loginButton) {
            loginButton.addEventListener("click", () => {
                this._gameEventService.switchPage(Page.Auth);
            });
        }

        if (logoutButton) {
            logoutButton.addEventListener("click", () => {
                this._gameEventService.switchPage(Page.UitlogMessage); // 👈 Stuur naar UitlogMessage-pagina
            });
        }
    }
}
